import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  standalone: true,
  selector: "app-prefix-htv",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-htv.component.html",
  styleUrl: "./prefix-htv.component.less",
})
export class PrefixHtvComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 5;
    this.characters = ALLOWED_CHARACTERS["htv"];
  }
}
